import script from "./FSubmitReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./FSubmitReport.vue?vue&type=script&setup=true&lang=ts"

import "./FSubmitReport.vue?vue&type=style&index=0&id=2d74582a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d74582a"]])

export default __exports__